import { IntegrationsApi } from '@quadminds/client-apis/integrations';

// Get the integration API URL from environment variables
const INTEGRATION_API_URL = process.env['NX_INTEGRATION_API_URL'];

if (!INTEGRATION_API_URL) {
    throw new Error('NX_INTEGRATION_API_URL environment variable is required but not set');
}

// Create the integrations API instance with the configured URL
export const integrationsApi = new IntegrationsApi({
    baseURL: INTEGRATION_API_URL,
    withCredentials: false,
    debug: true,
});
